import { render, staticRenderFns } from "./StoreOwner.vue?vue&type=template&id=3487abfa&scoped=true&"
import script from "./StoreOwner.vue?vue&type=script&lang=js&"
export * from "./StoreOwner.vue?vue&type=script&lang=js&"
import style0 from "./StoreOwner.vue?vue&type=style&index=0&id=3487abfa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3487abfa",
  null
  
)

export default component.exports